import { render } from "./ItemIndexSheetTile.vue?vue&type=template&id=5bed2afc&scoped=true"
import script from "./ItemIndexSheetTile.vue?vue&type=script&lang=js"
export * from "./ItemIndexSheetTile.vue?vue&type=script&lang=js"

import "./ItemIndexSheetTile.vue?vue&type=style&index=0&id=5bed2afc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bed2afc"

export default script